import React from 'react'
import { useSelector } from 'react-redux'
import assignmentSelectors from '../../../../../store/selectors/assignment.selectors'
import ReviewerDashboard from './ReviewerDashboard'
import TaDashboard from './TaDashboard'
import useQueryParam from '../../../../../hooks/useQueryParam'
import { DASHBOARD_TYPE_PARAM } from '../../../../../constants/query-params'

const DashboardSection = () => {
    const isOwner = useSelector(assignmentSelectors.isOwner)
    const ownerShouldSeeReviewerDashboard = useSelector(assignmentSelectors.ownerShouldSeeReviewerDashboard)
    const dashboardType = useQueryParam(DASHBOARD_TYPE_PARAM) || 'ta'

    if (!isOwner) return <ReviewerDashboard />
    
    if (ownerShouldSeeReviewerDashboard && dashboardType === 'reviewer') {
        return <ReviewerDashboard />
    }
    
    return <TaDashboard />
}

export default DashboardSection
